import $ from 'jquery';
import 'slick-carousel';
import { loadSVG } from '../../utils/load-svg';
import { debounce } from '../../utils/debounce';

const sliderServicesLoop = () => {
	const el = {
		target: '.mi-carousel__servicesLoop .elementor-loop-container',
	};

	let $target = $();

	const init = () => {
		$(function () {
			$target = $(el.target);
			if (!$(el.target).length) return;

			const $style = $target.find('style[id]');
			$style.prependTo($target.parent());

			exec();

			$(window).on('resize', debounce(exec, 200));
		});
	};

	const exec = () => {
		$target.on('init', function (event, slick) {
			console.log(slick);
			loadSVG('/wp-content/uploads/2025/11/ic-arrow-right.svg')
				.then((svgString) => {
					slick.$nextArrow.html(svgString);
				})
				.catch(console.error);
			loadSVG('/wp-content/uploads/2025/11/ic-arrow-left.svg')
				.then((svgString) => {
					slick.$prevArrow.html(svgString);
				})
				.catch(console.error);
		});
		$target.slick({
			mobileFirst: true,
			slidesToShow: 1.2,
			slidesToScroll: 1,
			adaptiveHeight: false,
			draggable: true,
			infinite: false,
			autoplay: false,
			speed: 500,
			nextArrow: '<button class="slick-arrow slick-next"></button>',
			prevArrow: '<button class="slick-arrow slick-prev"></button>',
			responsive: [
				{
					breakpoint: 600,
					settings: 'unslick',
				},
			],
		});
	};

	init();
};

try {
	sliderServicesLoop();
} catch (error) {
	console.error(error);
}
